import { render, staticRenderFns } from "./QuestionExam.vue?vue&type=template&id=0d49828d&scoped=true"
import script from "./QuestionExam.vue?vue&type=script&lang=js"
export * from "./QuestionExam.vue?vue&type=script&lang=js"
import style0 from "./QuestionExam.vue?vue&type=style&index=0&id=0d49828d&prod&lang=less&scoped=true"
import style1 from "./QuestionExam.vue?vue&type=style&index=1&id=0d49828d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d49828d",
  null
  
)

export default component.exports